import React, {use, useEffect} from "react";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";

const RedirectToAmazon: React.FC = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = `${import.meta.env.VITE_AMAZON_URL}`;
    }, 2000); // 2 seconds delay

    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-50'>
      <div className='flex flex-col items-center space-y-4'>
        <Spin
          size='large'
          indicator={<LoadingOutlined spin style={{fontSize: "125% rem"}} />}
        />
        <span className='text-lg font-medium text-gray-700'>
          SpotGenie redirects you to Amazon.in...
        </span>
      </div>
    </div>
  );
};

export default RedirectToAmazon;
